﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconGenderBigender } from "@tabler/icons-react";

export const GeneroIcon = IconGenderBigender;
export const GeneroHelpText = '* Aquí puede ver la lista de los generos del personal.';



export class catGenero extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "Genero";
        this.def.columns.c_category_id.defaultValue = "Genero";
        this.Title = "Género";
        this.HelpText = GeneroHelpText;
        this.Icon = GeneroIcon;
    }
}